import * as leadformConstants from '../constants';
import '../../../principles/polyfills/closest';

// Gets form associated with an element
export default function getForm(element) {
  return element.closest(leadformConstants.leadformTagNames.form);
}



// WEBPACK FOOTER //
// ./client/app/scripts/leadform/models/element/get_form.js